import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ExportCSVTranslationsApi, ImportOverviewProblemApi } from "../../../../services/types";
import { CsvImportProblemType } from "../../utils/types";

interface Props {
	translations: ExportCSVTranslationsApi;
	problems: ImportOverviewProblemApi[];
	problemType: CsvImportProblemType;
}

const CsvImportProblemCard = ({ translations, problems, problemType }: Props) => {
	const { t } = useTranslation("lib");
	const { problems_column_name } = translations;

	if (problems.length === 0) return null;

	return (
		<Card className="csv-import-problem-card">
			<h6>{t(`go_component.field.${problemType}.title`)}</h6>
			<Card.Body>
				<div className="table-responsive">
					<table className="table table-preview">
						<thead>
							<tr>
								<th>{t("common.word.name")}</th>
								<th>{problems_column_name}</th>
							</tr>
						</thead>
						<tbody>
							{problems.map(({ message, count }) => {
								const problemWithTranslation = translations.constraints[message];

								return (
									<tr key={message}>
										<td>{problemWithTranslation}</td>
										<td>{count}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			</Card.Body>
		</Card>
	);
};

export default CsvImportProblemCard;

// t(`go_component.field.errors.title`, { ns: "lib" })
// t(`go_component.field.warnings.title`, { ns: "lib" })
